import React, { Component } from 'react';
import { connect } from 'react-redux';

import { FOLDER } from 'constants/videosDashboard';
import { fetchSubFoldersCreator } from 'creators/moveModal';

import GridCell from 'components/videos-dashboard-ta/hierarchy-grid/grid-cell';

import './styles.less';

const HierarchyGrid = class extends Component {
  render() {
    const { checkedItems, isFetchingInitialFolders } = this.props;

    let gridCells = [];

    const checkedFolderIds = checkedItems
      .filter(item => item.type === FOLDER)
      .map(item => item.id);

    gridCells = this.generateChildren(null, checkedFolderIds, 1, false);

    return (
      <div
        className={`hierarchy-grid ${
          isFetchingInitialFolders ? 'loading' : ''
        }`}
      >
        {gridCells}
      </div>
    );
  }

  generateChildren = (folderId, checkedFolderIds, level, doNotRecurse) => {
    const { folders, openedFolderIds, openFolder, closeFolder } = this.props;

    if (!folderId) {
      return folders
        .map(folder => {
          if (folder.isTopLevel) {
            return (
              <GridCell
                closeFolder={closeFolder}
                checkedFolderIds={checkedFolderIds}
                doNotRecurse={doNotRecurse}
                folder={folder}
                generateChildren={this.generateChildren}
                key={folder.id}
                level={level}
                openedFolderIds={openedFolderIds}
                openFolder={openFolder}
              />
            );
          }

          return null;
        })
        .filter(folder => folder);
    }

    const folder = folders.find(folder => folder.id === folderId);

    return folder.children
      .map(folder => {
        return (
          <GridCell
            closeFolder={closeFolder}
            checkedFolderIds={checkedFolderIds}
            doNotRecurse={doNotRecurse}
            folder={folder}
            generateChildren={this.generateChildren}
            key={folder.id}
            level={level}
            openedFolderIds={openedFolderIds}
            openFolder={openFolder}
          />
        );
      })
      .filter(folder => folder);
  };
};

const mapStateToProps = state => {
  const {
    checked_items: checkedItems,
    folder_id: currentFolderId,
  } = state.videos_dashboard;

  const { folders, isFetchingInitialFolders } = state.moveModal;

  return {
    checkedItems,
    currentFolderId,
    isFetchingInitialFolders,
    folders,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSubFolders: folderId => dispatch(fetchSubFoldersCreator(folderId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HierarchyGrid);
